import {
  pdf,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { ARM_NAME, BASE_NAME, BRACE_NAME, COLUMN_NAME } from "./QuotationCartItem";
import storemaxLogo from "../assets/images/storemax.png";
import { useEffect, useState } from "react";
import { Backdrop, Box, Button, Fade, InputBase, InputLabel, MenuItem, Modal, Select, Typography, useTheme } from "@mui/material";
import { alpha, styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { tokens } from "../theme";
import { Spinner } from "react-bootstrap";
import PicklistPart from "./PicklistPartComponent";
import { useDispatch, useSelector } from "react-redux";
import { updatePickListQuotationParts } from "../features/cart/cartSlice";
import FormControl from "@mui/material/FormControl";
import { BEAM, FRAME } from "./PalletRackingPart";
import { FRAMES } from "../static/PickSlipAccessories";
import ArialUnicodeMS from '../assets/fontFamilies/Noto_Sans/NotoSans-Medium.ttf'; // Import the font file
import { toast } from "react-toastify";
import { ParseObject } from "./ExistingQuotation";
import Parse from "parse";
import { getAvailableQuantity, splitPickQuantities } from "../common/inventory";

Font.register({
  family: 'Arial Unicode MS',
  src: ArialUnicodeMS,
});

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    height: "100% !important",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  header: {
    marginVertical: "1%",
  },
  companyInfo: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: '10'
  },
  clientInfo: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "10px",
  },
  container: {
    padding: 20,
    flexGrow: 1,
  },
  rowHeader: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "lightgray",
    padding: "6px",
    borderRadius: "4px",
  },
  rowHeaderPicklistItems: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "lightgray",
    padding: "6px",
    borderRadius: "4px",
    marginTop: '10px',
  },
  row: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: "5px",
    fontFamily: 'Arial Unicode MS'
  },
  containerBillInfo: {
    width: "100%",
    padding: "10px",
    marginBottom: "15%",
    borderBottom: "1px solid lightgray",
    borderTop: "1px solid lightgray",
  },
  totalBillInfo: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: "5px",
  },
  rowBetween: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: "space-between",
  },
  itemText: {
    fontSize: "10px",
  },
  quantityText: {
    fontSize: "10px",
    minWidth: '20px',
    marginRight: "10px",
  },
  totalPriceText: {
    fontSize: "10px",
    marginRight: "40px",
  },
  totalPriceValue: {
    fontSize: "10px",
    marginRight: "20px",
  },
});

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  overflow: 'auto',
  height: '100%'
};

export default function Picklist(props) {
  const quotationItem = props.quotationItem;
  const disableDownloadButton = props.disableDownloadButton
  const [openPickListModal, setOpenPickListModal] = useState(false);
  const [vendorEmail, setVendorEmail] = useState('');
  const [vendorName, setVendorName] = useState();
  const [quoteReferenceNumber, setQuoteReferenceNumber] = useState(quotationItem?.get("quotationNumber"));
  const quotationParts = props.quotationParts;
  const revision = props.revision;
  const dispatch = useDispatch();
  const finalized = props.finalized;
  const pickListQuotationParts = useSelector((state) => state.cart.pickListQuotationParts);
  const [quotationPartsUpdated, setQuotationPartsUpdated] = useState([]);
  const quotationSections = props.quotationSections;
  const currentDate = quotationItem?.get("createdAt")?.toString().slice(0, 15);
  const quotationNumber = quotationItem?.get("quotationNumber");
  const [quotationPartDict, setQuotationPartDict] = useState({});
  const [sumOfQuotationPartDict, setSumOfQuotationPartDict] = useState({});
  const [columnPart, setColumnPart] = useState();
  const [basePart, setBasePart] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [suburbAndState, setSuburbAndState] = useState("");
  const [updatedPickListQuotationParts, setUpdatedPickListQuotationParts] = useState([]);
  const theme = useTheme();
  const client = quotationItem.get("client") ? quotationItem.get("client") : new ParseObject(quotationItem?.get('selectedClient')?.data);
  if (!client) {
    toast.warning('Please update the quotation and select a client first')
  }
  const colors = tokens(theme.palette.mode);
  const GreenSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: colors.greenAccent[600],
      '&:hover': {
        backgroundColor: alpha(colors.greenAccent[600], theme.palette.action.hoverOpacity),
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: colors.greenAccent[600],
    },
  }));
  const [calculateNutsAndBoltsEnabled, setCalculateNutsAndBoltsEnabled] = useState(false);
  const [picklistDocType, setPicklistDocType] = useState('internal');

  useEffect(() => {
    if (quotationParts.length > 0) {
      if (revision && finalized) {
        dispatch(updatePickListQuotationParts([...quotationParts]));
      } else if (!revision) {
        dispatch(updatePickListQuotationParts([...quotationParts]));
      }
    }
  }, [quotationParts]);

    useEffect(() => {
      const updateParts = async () => {
        try {
          const updatedPickListQuotationParts = await Promise.all(
            pickListQuotationParts.map(async (part) => {
              const liveInventoryQuantity = await getInventoryQuantity(part.id, part.className);
              return {
                ...part,
                liveInventoryQuantity: liveInventoryQuantity
              };
            })
          );
          setUpdatedPickListQuotationParts(updatedPickListQuotationParts);
        } catch (error) {
          // One failed lookup must not blank out the whole picklist - fall back to
          // the quantities saved on the quotation.
          console.error('Live inventory lookup failed, using saved quantities:', error);
          setUpdatedPickListQuotationParts([...pickListQuotationParts]);
        }
      };

      updateParts();
    }, [pickListQuotationParts]);

  const checkForFrameDims = (string) => {
    const regex = new RegExp(Object.keys(FRAMES).join("|"));
    const match = string.match(regex);

    if (match) {
      console.log("At least one item from the array is part of the string.");
      return match[0]
    } else {
      console.log("No item from the array is part of the string.");
      return false
    }
  }

  const handleClose = () => setOpenPickListModal(false);

  //   PICKLIST CONFIGURATIONS

  const basePlateDimMapping = { '900mm': '1389mm', '1200mm': '1689mm', '1500mm': '1989mm' };

  const findClosestValue = (input) => {
    let closestKey = null;
    let minDifference = Infinity;

    for (const key in basePlateDimMapping) {
      const keyNumber = parseFloat(key);
      const inputNumber = parseFloat(input);
      const difference = Math.abs(keyNumber - inputNumber);

      if (difference < minDifference) {
        minDifference = difference;
        closestKey = key;
      };
    }
    return basePlateDimMapping[closestKey];
  }

  useEffect(() => {
    const quotationPartsDict = {};
    const sumOfQuotationPartsDict = {};

    quotationParts?.map((part) => {
      return quotationPartsDict[part.section] = {}
    });

    quotationParts?.map((part) => {
      if (part.name === BRACE_NAME) {
        return quotationPartsDict[part.section][
          part.name + "_" + part?.layout
        ] = { quantity: part.quantity, finish: part.finish };
      } else if (part.name === FRAME || part.name === BEAM) {
        return quotationPartsDict[part.section][
          part.name
        ] = { quantity: part.quantity, finish: part.finish, dims: part.description };
      } else {
        return quotationPartsDict[part.section][part.name] = { quantity: part.quantity, finish: part.finish };
      }
    });

    quotationParts?.forEach((part) => {
      if (sumOfQuotationPartsDict[part.name]) {
        sumOfQuotationPartsDict[part.name] += 1;
      } else {
        sumOfQuotationPartsDict[part.name] = 1;
      }
    });

    setSumOfQuotationPartDict(sumOfQuotationPartsDict);


    setQuotationPartDict(quotationPartsDict);
    const column = quotationParts?.filter((part) => part?.name === "Column")[0];
    const base = quotationParts?.filter((part) => part?.name === "Base")[0];
    setColumnPart(column);
    setBasePart(base);
  }, [quotationParts]);


  const calculateColumnPartQuantityForPostAndBases = (
    columnPart,
    quotationPartDict,
    sectionIndex
  ) => {
    const heightFactors = {
      3000: 4,
      2000: 5,
      2972: 4,
      3048: 4,
      3657: 5,
      4267: 12,
      5029: 12,
      5791: 12,
      4867: 12,
    };

    const heightWithoutMM = (height) => parseInt(height.replace('mm', ''), 10);

    const closestHeight = Object.keys(heightFactors).reduce((prev, curr) => {
      const parsedPrev = heightWithoutMM(prev);
      const parsedCurr = heightWithoutMM(curr);
      const parsedColumnHeight = heightWithoutMM(columnPart?.height.trim());

      return (
        Math.abs(parsedCurr - parsedColumnHeight) <
          Math.abs(parsedPrev - parsedColumnHeight)
          ? curr
          : prev
      );
    });

    const quantity = quotationPartDict[sectionIndex + 1]?.Column?.quantity;
    const multiplicationFactor = heightFactors[heightWithoutMM(closestHeight)];

    return quantity ? quantity * multiplicationFactor : null;
  };



  const calculateColumnPartQuantityPostsAndBracingBrackets = (columnPart, quotationPartDict) => {
    const heightFactors = {
      3000: 6,
      2000: 4,
      2972: 6,
      3048: 6,
      3657: 8,
      4267: 8,
      5029: 10,
      5791: 10,
      4867: 10,
    };

    const heightWithoutMM = (height) => parseInt(height.replace("mm", ""), 10);

    const closestHeight = Object.keys(heightFactors).reduce((prev, curr) => {
      const parsedPrev = heightWithoutMM(prev);
      const parsedCurr = heightWithoutMM(curr);
      const parsedColumnHeight = heightWithoutMM(columnPart?.height.trim());

      return Math.abs(parsedCurr - parsedColumnHeight) <
        Math.abs(parsedPrev - parsedColumnHeight)
        ? curr
        : prev;
    });

    // Find the first available Column quantity in quotationPartDict
    let quantity = null;
    for (const section of Object.values(quotationPartDict)) {
      if (section?.Column?.quantity) {
        quantity = section.Column.quantity;
        break; // Stop once the first valid Column quantity is found
      }
    }

    const multiplicationFactor = heightFactors[heightWithoutMM(closestHeight)];
    return quantity ? quantity * multiplicationFactor : null;
  };

  const getInventoryQuantity = async (id, className) => {
      if (!id || !className) {
        console.error(`Cannot look up inventory without an ID and class:`, { id, className });
        return 0;
      }
      const query = new Parse.Query(Parse.Object.extend(className));
      query.equalTo("objectId", id);
      const inventoryObj = await query.find();
      if (inventoryObj.length === 0) {
        console.error(`No inventory found for ID: ${id} in class: ${className}`);
        return 0; // Return 0 if no inventory found
      };
      return inventoryObj[0].get("quantity");
  }

  // Light duty pick slips list M16*90 nut & bolt sets instead of base kits
  const isLightDuty = columnPart?.duty === "Light";

  const MyDocument = () => (
    <Document>
      {/* {Array.apply(null, {length: quotationSections[0].sectionCount}).map(
        (section, sectionIndex) => { */}
      return <Page size="a4" style={styles.page}>
        <View style={styles.container}>
          <View style={styles.header}>
            <View style={styles.companyInfo}>
              <View>
                <Image
                  style={{
                    width: "180px",
                    marginLeft: "-20",
                    marginTop: "-50px",
                  }}
                  src={storemaxLogo}
                />
              </View>
              <View>
                <Text
                  style={{
                    fontSize: "10px",
                    marginVertical: "2",
                    fontFamily: 'NOTO-SEMI-BOLD'
                  }}
                >
                  STOREMAX AUSTRALIA PTY. LTD.
                </Text>
                <Text style={{ fontSize: "8px", marginVertical: "2", fontFamily: 'NOTO-SEMI-BOLD', marginBottom: '5' }}>
                  ABN: 42 162 922 107
                </Text>
                <Text
                  style={{
                    fontSize: "8px",
                    marginVertical: "1",
                  }}
                >
                  Date: {currentDate}
                </Text>
              </View>
            </View>

            {columnPart?.duty.length > 0 && <View
              style={{
                textAlign: "center",
              }}
            >
              <Text style={{ fontSize: "10px" }}>
                {columnPart?.duty ? `${columnPart?.duty} Duty Cantilever` : null}
              </Text>
            </View>}

            <View
              style={{
                border: "1px solid lightgray",
                borderRadius: "4px",
                padding: "8px",
                textAlign: "center",
              }}
            >
              {vendorName?.trim().length > 0 && <Text style={{ fontSize: "10px" }}>
                Prepared For:{" "}
                {picklistDocType === 'internal' ? "Storemax Warehouse" : vendorName}
              </Text>}

              <Text style={{ fontSize: "10px" }}>
                {" "}
                {picklistDocType !== 'internal' && "Suburb & State: " + suburbAndState}
              </Text>

              {picklistDocType === 'internal' && <Text style={{ fontSize: "10px" }}>
                {vendorEmail}
              </Text>}
            </View>

            <Text style={{ fontSize: "10px", marginTop: "8px" }}>
              Order Reference Number:{" "}
              {quoteReferenceNumber}
            </Text>

            {picklistDocType === 'internal' && <Text style={{ fontSize: "10px", marginTop: "5px" }}>
              Customer: {client?.get("companyName")?.length > 0 ? client?.get("companyName") : client?.get("firstName")}{" "}
              {client?.get("lastName")}{" "}{client?.get("suburb")}{" "}{client?.get("state")}
            </Text>}

            {picklistDocType === 'internal' && <Text style={{ fontSize: "10px", marginTop: "5px" }}>
              Address: {client?.get("address")}
            </Text>}
          </View>

          <View style={styles.rowHeader}>
            <Text style={styles.itemText}>Name</Text>
            <View style={styles.rowBetween}>
              <Text style={{ fontSize: "10px", marginRight: "30px" }}>
                Finish
              </Text>
              <Text style={styles.quantityText}>Quantity</Text>
            </View>
          </View>

          {updatedPickListQuotationParts?.length > 0 && (() => {
            const partTotals = updatedPickListQuotationParts.reduce((acc, part) => {
              if (!part?.name) return acc;

              // Generate a unique identifier for identical parts
              const partId = `${part.name}_${part.height || ""}_${part.width || ""}_${part.depth || ""}_${part.bayCenter || ""}_${part.description || ""}_${part.brand || ""}_${part.finish || ""}`;

              if (!acc[partId]) {
                acc[partId] = { ...part, orderedQuantity: 0, availableByRecord: {} };
              }
              acc[partId].orderedQuantity += parseFloat(part.quantity) || 0;
              // An inventory record only contributes its stock once, however many
              // sections of the order the part turns up in.
              acc[partId].availableByRecord[part.id || part.partID] = getAvailableQuantity(part);

              return acc;
            }, {});

            // The internal list picks what the warehouse holds, the external list buys
            // the rest. Splitting the ordered quantity this way keeps a part that is
            // only partly in stock on both documents instead of losing either half.
            const partRows = Object.values(partTotals).map((part) => {
              const availableQuantity = Object.values(part.availableByRecord)
                .reduce((total, quantity) => total + quantity, 0);
              const { fromStock, shortfall } = splitPickQuantities(part.orderedQuantity, availableQuantity);

              return { ...part, totalQuantity: picklistDocType === 'internal' ? fromStock : shortfall };
            }).filter((part) => part.totalQuantity > 0);

            return (
              <View>
                {partRows.map((part, index) => (
                  <View key={index} style={styles.row}>
                    <Text style={styles.itemText}>
                      {part.name === COLUMN_NAME
                        ? `Column ${part.height} High/ ${part.width}`
                        : part.name === BASE_NAME
                          ? part.duty !== "Light"
                            ? `Base Side Plates ${part.width} ${part.sides} sides for ${part.armToSuitBase} Arms`
                            : `Base ${part.width} ${part.sides} sides for ${part.armToSuitBase} Arms`
                          : part.name === ARM_NAME
                            ? `Arm H ${part.height} - ${part.depth}`
                            : part.name === BRACE_NAME
                              ? `Brace ${part.bayCenter.split(" ")[0]} ${part.bayCenter.split(" ")[1]} c/c ${part.width}`
                              : (part.name === "Frame" || part.name === "Beam")
                                ? `${part.name} ${part.description} / ${part.brand}`
                                : `${part.name} ${part.description}`
                      }
                    </Text>

                    <View style={styles.rowBetween}>
                      <Text style={{ fontSize: "10px", marginRight: "50px" }}>
                        {part.finish === "Blue" ? "Powder Coated" : part.finish === "Galv" ? "Galvanized" : part.finish}
                      </Text>
                      <Text style={styles.quantityText}>
                        {picklistDocType === 'internal' && part.name === BASE_NAME && part.duty !== "Light"
                          ? part.totalQuantity * 2
                          : part.totalQuantity}
                      </Text>
                    </View>
                  </View>
                ))}
              </View>
            );
          })()}


          {/* PICKLIST ITEMS */}

          {calculateNutsAndBoltsEnabled && (
            <View>
              <View style={styles.rowHeaderPicklistItems}>
                <Text style={styles.itemText}>Name</Text>
                <View style={styles.rowBetween}>
                  <Text style={{ fontSize: "10px", marginRight: "30px" }}>Finish</Text>
                  <Text style={styles.quantityText}>Quantity</Text>
                </View>
              </View>

            {columnPart ? (
              Object.values(
                Object.entries(quotationPartDict).reduce((acc, [_, section]) => {
                  if (!section) return acc;

                  // Define part name mapping
                  const partNameMap = {
                    Bracing_Horizontal: { name: "Brace Brackets", part: 'Bracing_Horizontal', },
                    ...(isLightDuty
                      ? { Base_Bolts: { name: "Nut & Bolt Sets - M16*90", part: 'Column', } }
                      : { Base: { name: `Base kits ${basePart?.sides?.trim() === "1" ? "S/S" : "D/S"}`, part: 'Base', } }),
                    Arm: { name: (columnPart.duty === "Medium" || columnPart.duty === "Heavy") ? "Arm Pin - Ф30*130" : "Arm pin Ф16*90", part: 'Arm', },
                    Bolts_Nuts: {
                      name: (columnPart.duty === "Medium" || columnPart.duty === "Heavy")
                        ? "Bolts & Nuts for Posts & Bracing Brackets - M12*130"
                        : "Bolts & Nuts for Posts & Bracing Brackets - M10*80", part: 'Column',
                    },
                    Bracing_Bolts: { name: "Bolts & Nuts for Bracing - M10*30", part: 'Bracing_Horizontal', },
                    Arm_Lock: { name: "Arm Safety Lock Pin - Ф40*4.0", part: 'Arm', },
                    Dynabolt: {
                      name: (columnPart.duty === "Medium" || columnPart.duty === "Heavy")
                        ? "Dynabolt - M16x100mm"
                        : "Dynabolt - M12x80mm",
                      part: 'Column',
                    },
                    Packing_Shim: {
                      name: (columnPart.duty === "Medium" || columnPart.duty === "Heavy")
                        ? "Packing Shims - 100x200x2.0"
                        : "Packing Shims - 120 x 60 x 2mm",
                      part: 'Column'
                    }
                  };

                  Object.entries(partNameMap).forEach(([key, partName]) => {
                    const _partName = partNameMap[key].part
                    const part = section[_partName];
                    // if (!part) return;
                    console.log("key:", key, "| _partName:", _partName, "| part:", part, "| part?.quantity:", part?.quantity);
                    const finish = part?.finish === "Galv" ? "Galvanized" : "Zinc";
                    const quantity =
                      key === "Bracing_Horizontal" ? (part?.quantity || 0) * 2 :
                        key === "Base_Bolts" ? (part?.quantity || 0) * 5 :
                        key === "Base" ? (part?.quantity || 0 ):
                          key === "Bolts_Nuts" ? (calculateColumnPartQuantityPostsAndBracingBrackets(columnPart, quotationPartDict) || 0):
                            key === "Dynabolt"
                              ? basePart?.sides.trim() === "1" && (basePart?.duty === "Medium" || basePart?.duty === "Heavy") ? (part?.quantity || 0)* 3
                                : basePart?.sides.trim() === "2" && (basePart?.duty === "Medium" || basePart?.duty === "Heavy") ? (part?.quantity || 0) * 4
                                  : basePart?.sides.trim() === "1" && basePart?.duty === "Light" ? (part?.quantity || 0) * 2
                                    : basePart?.sides.trim() === "2" && basePart?.duty === "Light" ? (part?.quantity || 0) * 4
                                      : null
                              : key === "Bracing_Bolts" ? (part?.quantity || 0) * 2
                                : key === "Packing_Shim" ? (part?.quantity || 0) * 3 : (part?.quantity || 0);


                    const id = `${partName.name}-${finish}`;

                    if (!acc[id]) {
                      acc[id] = { partName, finish, quantity: 0 };
                    }
                    acc[id].quantity += quantity;
                  });
                  return acc;
                }, {})
              ).map(({ partName, finish, quantity }, index) => (
                <View style={styles.row} key={index}>
                  <Text style={styles.itemText}>{partName.name}</Text>
                  <View style={styles.rowBetween}>
                    <Text style={{ fontSize: "10px", marginRight: "50px" }}>{finish}</Text>
                    <Text style={styles.quantityText}>{quantity}</Text>
                  </View>
                </View>
              ))
              ) : (
      quotationParts.map((part, index) => {
        console.log("Current Part:", part);
        let rows = []; 
          switch (part.name) {
          case "Arm":
            // ✅ Arm pin row
            rows.push({
              name:
                part.duty === "Medium" || part.duty === "Heavy"
                  ? "Arm Pin - Ф30*130"
                  : "Arm pin Ф16*90",
              finish: part.finish === "Galv" ? "Galvanized" : "Zinc",
              quantity: part.quantity || 0,
            });

            // ✅ Arm lock row
            rows.push({
              name: "Arm Safety Lock Pin - Ф40*4.0",
              finish: part.finish === "Galv" ? "Galvanized" : "Zinc",
              quantity: part.quantity || 0,
            });
            break;

          case "Base":
          // Base calculation (light duty uses M16*90 nut & bolt sets instead of base kits)
          if (part.duty !== "Light") {
            rows.push({
              name: `Base kits ${part.sides?.trim() === "1" ? "S/S" : "D/S"}`,
              finish: part.finish === "Galv" ? "Galvanized" : "Zinc",
              quantity: part.quantity || 0,
            });
          }

          // Dynabolt calculation (only when Base is present)
          rows.push({
            name:
              part.duty === "Medium" || part.duty === "Heavy"
                ? "Dynabolt - M16x100mm"
                : "Dynabolt - M12x80mm",
            finish: part.finish === "Galv" ? "Galvanized" : "Zinc",
            quantity:
              part.sides?.trim() === "1" &&
              (part.duty === "Medium" || part.duty === "Heavy")
                ? (part.quantity || 0) * 3
                : part.sides?.trim() === "2" &&
                  (part.duty === "Medium" || part.duty === "Heavy")
                ? (part.quantity || 0) * 4
                : part.sides?.trim() === "1" && part.duty === "Light"
                ? (part.quantity || 0) * 2
                : part.sides?.trim() === "2" && part.duty === "Light"
                ? (part.quantity || 0) * 4
                : 0,
            });

            // Packing Shims calculation
            rows.push({
              name:
                part.duty === "Medium" || part.duty === "Heavy"
                  ? "Packing Shims - 100x200x2.0"
                  : "Packing Shims - 120x60x2mm",
              finish: part.finish === "Galv" ? "Galvanized" : "Zinc",
              quantity: (part.quantity || 0) * 3,
            });
            break;

            case "Bracing_Horizontal":
            // Brace Brackets
            rows.push({
              name: "Brace Brackets",
              finish: part.finish === "Galv" ? "Galvanized" : "Zinc",
              quantity: (part.quantity || 0) * 2, // 2 brackets per bracing
            });

            // Bolts & Nuts for Bracing
            rows.push({
              name: "Bolts & Nuts for Bracing - M10*30",
              finish: part.finish === "Galv" ? "Galvanized" : "Zinc",
              quantity: (part.quantity || 0) * 2, // 2 sets per H bracing
            });
            break;
        }

        return rows.map((row, rowIndex) => (
          <View style={styles.row} key={index}>
            <Text style={styles.itemText}>{row.name}</Text>
            <View style={styles.rowBetween}>
              <Text style={{ fontSize: "10px", marginRight: "50px" }}>{row.finish}</Text>
              <Text style={styles.quantityText}>{row.quantity}</Text>
            </View>
          </View>
        ));
      })
    )}
            


              <View style={styles.row}>
                <Text style={styles.itemText}>Load Sign</Text>
                <Text style={styles.quantityText}>1</Text>
              </View>
            </View>
            )
          }


          {calculateNutsAndBoltsEnabled && (
            <View>
              {/* <View style={styles.rowHeaderPicklistItems}>
                <Text style={styles.itemText}>Name</Text>
                <View style={styles.rowBetween}>
                  <Text style={{ fontSize: "10px", marginRight: "30px" }}>Finish</Text>
                  <Text style={styles.quantityText}>Quantity</Text>
                </View>
              </View> */}

              {Object.values(
                Object.values(quotationPartDict).reduce((acc, section) => {
                  if (!section || !section.Frame) return acc;

                  // Process Frame Components
                  const frameDims = checkForFrameDims(section.Frame?.dims);
                  if (frameDims && FRAMES[frameDims]) {
                    FRAMES[frameDims].forEach((item) => {
                      const partName = `${item.name} ${item.dims}`;
                      const quantity = section.Frame?.quantity * item.quantity;

                      if (!acc[partName]) {
                        acc[partName] = { partName, quantity: 0 };
                      }
                      acc[partName].quantity += quantity;
                    });
                  }

                  // Process Spring Lock Condition
                  if (section.Beam?.dims?.includes("L 2591mm W 100") || section.Beam?.dims?.includes("L 2743mm W 100")) {
                    const partName = "Spring Lock";
                    const quantity = section.Beam?.quantity * 2;

                    if (!acc[partName]) {
                      acc[partName] = { partName, quantity: 0 };
                    }
                    acc[partName].quantity += quantity;
                  }

                  return acc;
                }, {}) // `reduce()` returns an object
              ).map(({ partName, quantity }, index) => ( // Convert to array before `.map()`
                <View style={styles.row} key={index}>
                  <Text style={styles.itemText}>{partName}</Text>
                  <Text style={styles.quantityText}>{quantity}</Text>
                </View>
              ))}
            </View>
          )}


        </View>
      </Page>
      {/* }
      )} */}
    </Document>
  );

  const saveFile = async () => {
  try {
    setIsLoading(true);
    setOpenPickListModal(false);

    const blob = await pdf(<MyDocument />).toBlob();
    saveAs(blob, `picklist_${picklistDocType}_${quoteReferenceNumber}.pdf`);
    // console.log("✅ PDF Downloaded Successfully");
  } catch (err) {
    console.error("PDF Rendering Error:", err);
  } finally {
    setIsLoading(false);
  }
};

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openPickListModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openPickListModal}>
          <Box sx={modalStyle}>
            <Typography
              id="transition-modal-description"
              className="secondary-color text-center"
              sx={{ mt: 2 }}
            >
              Picklist Metadata
            </Typography>

            <FormControl style={{ width: '100%' }} className=" my-4 text-center">
              <InputLabel id="demo-simple-select-label">Picklist Creation Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={picklistDocType}
                label="Finish"
                onChange={(e) => setPicklistDocType(e.target.value)}
              >
                <MenuItem value={"external"}>External Vendor</MenuItem>
                <MenuItem value={"internal"}>Internal Warehouse Inventory</MenuItem>
              </Select>
            </FormControl>

            <Box sx={{ width: "100%" }}>
              {picklistDocType === 'external' && <>
                <Typography>Vendor Name</Typography>
                <InputBase
                  data-tip
                  data-for="title"
                  placeholder="Vendor Name"
                  className="outlined border rounded px-2 mx-1"
                  name="title"
                  value={vendorName}
                  onChange={(e) => setVendorName(e.target.value)}
                  onBlur={() => { }}
                  sx={{ flex: 1, width: "100%" }}
                />

                <Typography>Suburb/ State</Typography>
                <InputBase
                  data-tip
                  data-for="title"
                  placeholder="Vendor Name"
                  className="outlined border rounded px-2 mx-1"
                  name="title"
                  value={suburbAndState}
                  onChange={(e) => setSuburbAndState(e.target.value)}
                  onBlur={() => { }}
                  sx={{ flex: 1, width: "100%" }}
                />

                <Typography sx={{ marginTop: "1em" }}>Vendor Email</Typography>
                <InputBase
                  data-tip
                  data-for="title"
                  placeholder="Vendor Name"
                  className="outlined border rounded px-2 mx-1"
                  name="title"
                  value={vendorEmail}
                  onChange={(e) => setVendorEmail(e.target.value)}
                  onBlur={() => { }}
                  sx={{ flex: 1, width: "100%" }}
                />
              </>}

              <Typography sx={{ marginTop: "1em" }}>
                Our PO/ Your Quote
              </Typography>
              <InputBase
                data-tip
                data-for="title"
                placeholder="Quote Number"
                className="outlined border rounded px-2 mx-1"
                name="title"
                value={quoteReferenceNumber}
                onChange={(e) => setQuoteReferenceNumber(e.target.value)}
                onBlur={() => { }}
                sx={{ flex: 1, width: "100%" }}
              />

              <Box display='flex' justifyContent='space-between' alignItems='center'>
                <Typography>Calculate Nuts and Bolts for Cantilever</Typography>
                <GreenSwitch
                  checked={calculateNutsAndBoltsEnabled}
                  onChange={(e) => setCalculateNutsAndBoltsEnabled(e.target.checked)}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
              </Box>

              {Array.apply(null, { length: quotationSections[0].sectionCount }).map((section, sectionIndex) => {

                return <Box key={sectionIndex}>{<Typography mt='1em'>Section - {sectionIndex + 1}</Typography>}{quotationParts?.map((part, index) => {
                  return (
                    part?.name &&
                    part.section === sectionIndex + 1 && (
                      <PicklistPart
                        key={index}
                        quotationParts={quotationParts}
                        part={part}
                        setQuotationPartsUpdated={setQuotationPartsUpdated}
                        picklistDocType={picklistDocType}
                      />
                    )
                  );
                })}
                </Box>
              })}
            </Box>

            <Box display="flex" justifyContent="space-between" mt="2em">
              <Button
                sx={{
                  backgroundColor: colors.blueAccent[700],
                  color: colors.grey[100],
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "10px 20px",
                }}
                onClick={handleClose}
              >
                Cancel
              </Button>

              <Button
                sx={{
                  backgroundColor: colors.blueAccent[700],
                  color: colors.grey[100],
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "10px 20px",
                }}
                onClick={saveFile}
              >
                Confirm
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
      <Button
        sx={{
          backgroundColor: colors.blueAccent[700],
          color: colors.grey[100],
          fontSize: "14px",
          fontWeight: "bold",
          padding: "5px 20px",
          mt: "1em",
          mr: "1em",
        }}
        disabled={isLoading || disableDownloadButton}
        onClick={() => setOpenPickListModal(true)}
      >
        {!isLoading ? (
          "Download Picklist"
        ) : (
          <Spinner
            animation="border"
            role="status"
            size="sm"
            variant="primary"
          />
        )}
      </Button>
    </>
  );
}
